import { useProductPlanFormModelContext } from "../../../../../context";

export const useDoNotCountKidsAsStock = () => {
	const { viewModel, onSetViewModel } = useProductPlanFormModelContext();
	const { doNotCountKidsAsStock } = viewModel;

	return {
		doNotCountKidsAsStock,
		onSetDoNotCountKidsAsStock: (value: boolean) => {
			onSetViewModel([
				{
					key: "doNotCountKidsAsStock",
					value: {
						...doNotCountKidsAsStock,
						isEdited: true,
						value,
					},
				},
			]);
		},
	};
};
